import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

import { ClassNameComponent } from '@/utils/ClassNameComponent';
import LessonNameMember from './LessonNameMember';
import LessonProgressPresence from './LessonProgressPresence';
import LessonProgressBarMember from './LessonProgressRoundedBar';
import LessonProgressStats from './LessonProgressStats';

type Props = {
  className?: ClassNameComponent;
  disabled?: boolean;
};

function LessonProgressMember(props: PropsWithChildren<Props>) {
  const { children, className, disabled } = props;

  return (
    <li
      className={twMerge(
        'flex overflow-x-hidden',
        className?.base,
        disabled ? 'disabled pointer-events-none' : '',
      )}
    >
      {children}
    </li>
  );
}

LessonProgressMember.RoundedProgressBar = LessonProgressBarMember;
LessonProgressMember.Name = LessonNameMember;
LessonProgressMember.Stats = LessonProgressStats;
LessonProgressMember.Presence = LessonProgressPresence;

export default LessonProgressMember;
